<template>
  <div id="app">
    <div class="hero is-fullheight">
      <div class="hero-body has-text-centered">
        <h1 class="hero-title">{{ $t('home.hero.title') }}</h1>
        <button class="play-button" @click="showVideo()">
          <img src="../assets/images/icons/play-circle-outline-white.svg" alt="">
        </button>
        <div class="download-button-container">
          <a class="download-button" href="https://itunes.apple.com/app/cinenow/id1216826213">
            <img :src="$t('home.hero.appStoreButton')" :alt="$t('home.hero.appStoreAlt')">
          </a>
          <a class="download-button" href="https://play.google.com/store/apps/details?id=com.selectic.cinomatch">
            <img :src="$t('home.hero.googlePlayButton')" :alt="$t('home.hero.googlePlayAlt')">
          </a>
        </div>
        <button class="anchor-button" @click="scrollToContent()">
          <img src="../assets/images/icons/keyboard-arrow-down-white.svg" alt="">
        </button>
      </div>
    </div>
    <section class="features section" ref="content">
      <mobile-demo>
        <mobile-demo-feature :title="$t('home.features.feature1.title')" :screenshootSrc="require('../assets/images/screens/home_fr.png')">
          {{ $t('home.features.feature1.body') }}
        </mobile-demo-feature>
        <mobile-demo-feature :title="$t('home.features.feature2.title')" :screenshootSrc="require('../assets/images/screens/user_fr.png')">
          {{ $t('home.features.feature2.body') }}
        </mobile-demo-feature>
        <mobile-demo-feature :title="$t('home.features.feature3.title')" :screenshootSrc="require('../assets/images/screens/chat_fr.png')">
          {{ $t('home.features.feature3.body') }}
        </mobile-demo-feature>
      </mobile-demo>
    </section>

    <div class="modal is-active" v-if="isVideoVisible">
      <div class="modal-background" @click="hideVideo()"></div>
      <div class="modal-content">
        <youtube class="trailer-video" :video-id="$t('home.hero.video')" :player-vars="{ autoplay: 1 }" @ended="hideVideo()"></youtube>
      </div>
      <div class="modal-close" @click="hideVideo()"></div>
    </div>
  </div>
</template>

<script>
import MobileDemo from '@/components/MobileDemo'
import MobileDemoFeature from '@/components/MobileDemoFeature'
import MobileMockup from '@/components/MobileMockup'
import ContestForm from '@/components/ContestForm.vue'

export default {
  metaInfo () {
    return {
      titleTemplate: null,

      meta: [
        { name: 'description', content: this.$t('home.description') }
      ]
    }
  },
  data () {
    return {
      isVideoVisible: false
    }
  },
  methods: {
    showVideo: function () {
      this.isVideoVisible = true
    },
    hideVideo: function () {
      this.isVideoVisible = false
    },
    scrollToContent: function () {
      this.$SmoothScroll(this.$refs.content)
    }
  },
  components: {
    MobileDemo,
    MobileDemoFeature,
    MobileMockup,
    ContestForm
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/styles/_variables.scss';

.hero {
  background: url('../assets/images/hero/banner.jpg') no-repeat top center;
  background-size: cover; // text-align: center;
  // align-items: center;
  // justify-content: center;
  // padding: 0 5rem;
  // background-color: black;
  &.is-fullheight {
    min-height: calc(100vh - 3.25rem)
  }

  .hero-body {
    flex-direction: column;

    &>* {
      margin: 1rem 0;

      &:last-child {
        margin-bottom: 0;
      }
    } // .hero-video {
    //   position: absolute;
    //   top: 0;
    //   left: 0;
    //   right: 0;
    //   bottom: 0;
    // }
    .hero-title {
      margin-top: auto;
      font-size: 1.5rem;
      text-transform: uppercase;
    }

    .play-button {
      background: none;
      border: none;
      width: 80px;
      color: white;
      outline: none;
      cursor: pointer;

      img {
        width: 100%;
      }
    }

    .download-button {
      display: inline-block;
      width: 150px;
      background: none;
      border: none;
      margin: 0 1em;
      cursor: pointer;
    }

    .anchor-button {
      background: none;
      border: none;
      color: white;
      width: 50px;
      outline: none;
      margin-top: auto;
      cursor: pointer;

      img {
        width: 100%;
      }
    }
  }
}

.title {
  color: $white;

  &.is-1 {
    padding: 2em 0em 2em 0;
  }
}

.home-container {
  position: relative;
}

.home-bottom {
  background: $purple;
  background: linear-gradient(to right, $purple 0%, $purple-bis 74%, $purple-ter 100%);
}

.home-bottom-inner {
  background: none;
}

.contest-img-container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  text-align: center;
}

.contest-img {
  width: 200px;
}

.mockup {
  position: absolute;
  bottom: 3rem;
  right: 1.5rem;
  width: 288px;
}


.modal {
  .modal-content {
    width: 1200px;
  }
  .trailer-video {
    position: relative;
    padding-bottom: 56.25%; /* 16:9 */
    height: 0;
  }

  .trailer-video /deep/ iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}


@media screen and (min-width: $tablet) {
  // .home-top-inner {
  //   padding-right: 35%;
  // }
  .home-bottom-inner {
    padding-right: 340px;
  }

  .home-top-inner {
    padding-right: 340px;
  }

  .hero {
    .hero-body {
      .hero-title {
        font-size: 3.5rem;
      }

      .download-button {
        width: 240px;
      }

      .play-button {
        width: 120px;
      }

      .anchor-button {
        width: 80px;
      }
    }
  }

  .modal {
    .modal-content {
      max-width: calc(100vw - 80px);
    }
  }
}

@media screen and (min-height: 800px) {
  .hero {
    .hero-body {
      .hero-title {
        margin-top: 25%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Home.vue?2674eeaa